import React from "react";
import AboutSticky from "./AboutSticky";
import AboutScrool from "./AboutScrool";
import { useQuery } from "react-query";
import { BASEURL } from "../../../../../utils/BaseUrl";
import axios from "axios";
import ResposivePolicy from "./ResposivePolicy";
import useGetData from "../../../../../hooks/apihooks/useGetData";
import AboutStickyCard from "./new/AboutStickyCard";

const ScroolSticky = () => {
  const { data, isLoading, isError } = useGetData(
    "about-policy",
    "getAllpolicy"
  );
  return (
    <div className="flex w-full container mx-auto ">
      <ResposivePolicy data={data} />
      {/* <div className="w-1/2 lg:block md:hidden sm:hidden max-sm:hidden ">
        <AboutSticky data={data} />
      </div>
      <div className="w-1/2 ">
        <AboutScrool data={data} />
      </div> */}
      <div className="lg:block md:hidden sm:hidden max-sm:hidden">
        <AboutStickyCard data={data} />
      </div>
    </div>
  );
};

export default ScroolSticky;
